var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.loggedIn)?_c('ComponentWithPropertiesInstance',{key:_vm.root.key,attrs:{"component":_vm.root}}):(_vm.hasToken)?_c('LoadingView',{key:"loading-view"}):_c('ComponentWithPropertiesInstance',{key:_vm.loginRoot.key,attrs:{"component":_vm.loginRoot}})
}
var staticRenderFns = []

export { render, staticRenderFns }